import createMuiTheme from 'material-ui-next/styles/createMuiTheme'
import blueGrey from 'material-ui-next/colors/blueGrey'
import orange from 'material-ui-next/colors/orange'
import deepOrange from 'material-ui-next/colors/deepOrange'
import green from 'material-ui-next/colors/green'

export const singleColors = {
    primary1Color: '#f4941e',
    primaryColorMute: '#bc6600',
    secondaryColor: blueGrey[700],
    accent1Color: '#f4941e',
    textColor: 'rgba(0,0,0,0.8)',
    errorColor: deepOrange.A700,
    successColor: green.A700,
    labelColor: 'rgba(0, 0, 0, 0.8)',
    gray: 'rgb(224, 224, 224)'

}

export const layers = {
    bottom: 0,
    middle: 100,
    front: 1200,
    overlay: 1300
}

export const palette = {
    primary: orange,
    secondary: blueGrey,
}

export const theme =
    createMuiTheme({
        palette,
    })

export const colors = {
    error: deepOrange,
    success: green,
}

export const tabs = {
    tabContent: {
        display: 'flex',
        boxSizing: 'border-box',
        padding: '32px',
        flexWrap: 'wrap',
    },
    tabForm: {
        flex: '1',
    },
    tabInput: {
        margin: '8px 0',
        minWidth: 'calc(50% - 16px)',
        flex: 'none',
        minHeight: '72px',
        marginRight: '16px',
    }
}

export const generalStyles = {
    fab: {
        position: 'fixed',
        zIndex: layers.front,
        right: '32px',
    },
    primaryFab: {
        bottom: '32px',
    },
    secondaryFab: {
        bottom: '112px',
    },
    lineColor: 'rgb(224, 224, 224)'

}

export const card = {
    card: {
        margin: '8px',
        padding: '24px',
        flex: '1'
    },
    cardRow: {
        display: 'flex',
        flexDirection: 'row',
        width: '100 %'
    },
    cardColumn: {
        flex: 1
    }
    ,
    cardHeader: {
        fontWeight: 400,
        padding: '16px',
        margin: 0,
        fontSize: '20px'
    }
    ,
    cardContent: {
        padding: '16px'
    },
    cardFooter: {
        padding: '16px'
    },
    divider: {
        width: '1px',
        background: generalStyles.lineColor,
        margin: '0 48px'
    },
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Style.ts